import React, { Component } from 'react';
import { Form, Input, InputNumber, Icon } from 'components/antd';
import OutsideClickHandler from 'react-outside-click-handler';
import { trim } from 'lodash-es';
import styles from './TableBuilder.module.scss';
import { EditableContext } from './TableRow';

const FormItem = Form.Item;

interface EditableCellProps {
	record: any;
	handleSave: any;
	col: any;
	index: number;
}

class EditableCell extends Component<EditableCellProps> {
	input: any;
	form: any;
	// need to save input value in buffer for saving
	value?: string;
	// flag to reset changes
	isReset?: boolean;

	state = {
		editing: false,
	};

	componentDidUpdate(_prevProps: any, prevState: any) {
		const { editing } = this.state;
		const prevEditing = prevState.editing;

		// if we were editing input and closed it
		if (prevEditing && !editing) {
			// if we have value and we didn't ckick on reset btn
			if (trim(this.value) && !this.isReset) {
				this.save();
			}

			this.isReset = false;
		}
	}

	toggleEdit = () => {
		const editing = !this.state.editing;
		this.setState({ editing }, () => {
			if (editing) {
				this.input.focus();
			}
		});
	};

	save = (e?: React.SyntheticEvent) => {
		const { record, handleSave, col = {} } = this.props;
		const { dataIndex } = col;

		const currentId = e ? e.currentTarget.id : dataIndex;

		this.form.validateFields((error: any, _values: any) => {
			if (error && error[currentId]) {
				return;
			}
			let resultValue: any = this.value;
			if (this.value === '') {
				// BE requirement
				resultValue = null;
			}

			handleSave({ ...record, ...{ [dataIndex]: resultValue } });
		});
	};

	onChange = (value: any) => {
		if (typeof value === 'object') {
			this.value = value.target.value;
		} else {
			this.value = value;
		}
	};

	onReset = () => {
		this.isReset = true;
		this.toggleEdit();
	};

	render() {
		const { editing } = this.state;
		const { col = {}, record, index, handleSave, ...restProps } = this.props;
		const { editable, dataIndex, titleText, precision, step, isNumberValue } = col;

		return (
			<td {...restProps}>
				<div className={styles.Wrapper}>
					{editable ? (
						<EditableContext.Consumer>
							{(form: any) => {
								this.form = form;
								return editing ? (
									<OutsideClickHandler onOutsideClick={this.toggleEdit}>
										<FormItem className={styles.editableCell}>
											{form.getFieldDecorator(dataIndex, {
												rules: [
													{
														required: true,
														message: `${titleText} is required`,
													},
												],
												initialValue: record[dataIndex],
											})(
												isNumberValue ? (
													<InputNumber
														autoComplete="off"
														className={styles.editableRowInput}
														ref={node => (this.input = node)}
														precision={precision || 0}
														step={step}
														onChange={this.onChange}
													/>
												) : (
													<Input
														autoComplete="off"
														className={styles.editableRowInput}
														ref={node => (this.input = node)}
														onChange={this.onChange}
														onPressEnter={this.toggleEdit}
													/>
												)
											)}
											<div className={styles.editableRowControls}>
												<span onClick={this.toggleEdit}>
													<Icon type="check" />
												</span>
												<span onClick={this.onReset}>
													<Icon type="cancel" />
												</span>
											</div>
										</FormItem>
									</OutsideClickHandler>
								) : (
									<div className={styles.readCell} onClick={this.toggleEdit}>
										{restProps.children}
										<Icon type="pen" />
									</div>
								);
							}}
						</EditableContext.Consumer>
					) : (
						restProps.children
					)}
				</div>
			</td>
		);
	}
}

export { EditableCell };
